export default {
  common: {
    backToLogin: '← Zpět na přihlášení',
    backToStore: 'Zpět do obchodu',
    footer: {
      copyright: '© {year} KeyzoStore. Všechna práva vyhrazena.',
      terms: 'Obchodní podmínky',
      privacy: 'Zásady ochrany osobních údajů',
      cookies: 'Zásady používání souborů cookie',
    },
    logo: {
      ariaLabel: 'KeyzoStore — domů',
      alt: 'KeyzoStore',
    },
    showPassword: 'Zobrazit heslo',
    hidePassword: 'Skrýt heslo',
    captchaRequired: 'Dokončete prosím ověření.',
    // vue-i18n reads a bare "@" as linked-message syntax; {'@'} is the literal escape.
    emailPlaceholder: "jmeno{'@'}priklad.cz",
  },

  validation: {
    missingBoth: 'Zadejte prosím svou e-mailovou adresu a heslo.',
    missingEmail: 'Zadejte prosím svou e-mailovou adresu.',
    missingPassword: 'Zadejte prosím své heslo.',
    invalidEmail: 'Zadejte prosím platnou e-mailovou adresu.',
    invalidEmailMissingPassword: 'Zadejte prosím platnou e-mailovou adresu a své heslo.',
  },

  password: {
    hint: 'Minimálně 8 znaků, musí obsahovat alespoň jedno písmeno a jednu číslici',
    strength: {
      weak: 'Slabé',
      fair: 'Průměrné',
      good: 'Dobré',
      strong: 'Silné',
    },
  },

  login: {
    heading: 'Vítejte zpět',
    subtitle: 'Přihlaste se a získejte přístup ke svým klíčům, objednávkám a peněžence',
    emailLabel: 'E-mailová adresa',
    passwordLabel: 'Heslo',
    forgotPassword: 'Zapomněli jste heslo?',
    submit: 'Přihlásit se',
    submitting: 'Přihlašování…',
    noAccount: 'Nemáte účet?',
    signUp: 'Registrovat se',
    errorFallback: 'Přihlášení se nezdařilo',
    invalidCredentials: 'Nesprávný e-mail nebo heslo.',

    forgot: {
      heading: 'Obnovte si heslo',
      subtitle: 'Zadejte svůj e-mail a my vám zašleme odkaz pro obnovení hesla',
      emailLabel: 'E-mailová adresa',
      submit: 'Odeslat odkaz pro obnovení',
      submitting: 'Odesílání…',
      errorFallback: 'E-mail pro obnovení hesla se nepodařilo odeslat',
    },

    sent: {
      heading: 'Zkontrolujte svou schránku',
      subtitle: 'Odkaz pro obnovení hesla jsme odeslali na váš e-mail',
      openMail: 'Otevřít e-mailovou aplikaci',
    },
  },

  register: {
    heading: 'Vytvořte si účet',
    subtitle: 'Přidejte se k tisícům hráčů, kteří nakupují klíče za férové evropské ceny',
    emailLabel: 'E-mailová adresa',
    emailPlaceholder: "vy{'@'}priklad.cz",
    passwordLabel: 'Heslo',
    termsText: 'Souhlasím s',
    termsLink: 'Obchodními podmínkami',
    and: 'a',
    privacyLink: 'Zásadami ochrany osobních údajů',
    alreadyAccount: 'Už máte účet?',
    signIn: 'Přihlásit se',
    submit: 'Vytvořit účet',
    submitting: 'Vytváření účtu…',
    errorTerms: 'Musíte souhlasit s Obchodními podmínkami a Zásadami ochrany osobních údajů.',
    errorPassword: 'Heslo musí mít alespoň 8 znaků a obsahovat písmeno a číslici.',
    errorCaptcha: 'Dokončete prosím ověření.',
    errorFallback: 'Registrace se nezdařila',
  },

  reset: {
    heading: 'Obnovte si heslo',
    subtitle: 'Zvolte nové heslo pro svůj účet.',
    newPasswordLabel: 'Nové heslo',
    confirmLabel: 'Potvrdit nové heslo',
    mismatch: 'Hesla se zatím neshodují.',
    submit: 'Obnovit heslo',
    submitting: 'Ukládání…',
    errorPassword: 'Heslo musí mít alespoň 8 znaků a obsahovat písmeno a číslici.',
    errorMismatch: 'Hesla se neshodují.',
    errorCaptcha: 'Dokončete prosím ověření.',
    errorExpired: 'Tento odkaz vypršel nebo je neplatný.',
    errorMissingToken: 'Chybí token pro obnovení hesla. Použijte odkaz z e-mailu pro obnovení.',
    invalidToken: {
      heading: 'Odkaz již není platný',
      backToLogin: 'Zpět na přihlášení',
    },
    success: {
      heading: 'Heslo bylo aktualizováno',
      body: 'Nyní se můžete přihlásit pomocí nového hesla. Ostatní relace byly z bezpečnostních důvodů odhlášeny.',
      continueToLogin: 'Pokračovat na přihlášení',
    },
  },

  verify: {
    verifying: {
      heading: 'Ověřujeme váš e-mail…',
      body: 'Chvíli strpení, potvrzujeme odkaz.',
    },
    success: {
      heading: 'E-mail byl ověřen!',
      bodyKyc: 'Váš e-mail byl potvrzen. Můžete nakupovat položky do hodnoty 50 €. Pro větší nákupy dokončete ověření totožnosti (KYC) ve svém účtu.',
      bodyNoKyc: 'Váš e-mail byl potvrzen. Vše je připraveno, můžete začít nakupovat.',
      goToDashboard: 'Přejít na přehled účtu',
      browseCatalog: 'Procházet katalog →',
    },
    error: {
      heading: 'Platnost ověřovacího odkazu vypršela',
      missingToken: 'Chybí ověřovací token. Odkaz mohl být vložen nesprávně.',
      expiredFallback: 'Tento odkaz vypršel nebo je neplatný. Ověřovací odkazy jsou platné 24 hodin.',
      resend: 'Odeslat ověřovací e-mail znovu',
      resendSent: 'Ověřovací e-mail odeslán',
      sentConfirmation: 'Ověřovací e-mail byl odeslán. Zkontrolujte svou schránku.',
      backToLogin: '← Zpět na přihlášení',
    },
  },
};
